<template>
    <relatorio-page :titulo=" 'Relatório Recurso Pessoal' " :cabecalhoCompleto="true" :exportarExcel="false" :paisagem="true">

        <v-row v-if="item.length > 0">

            <v-col cols="12">
                <v-simple-table id="tabela" dense class="py-2 text-caption" v-if="item.length > 0">
                    <template v-slot: default>
                        <thead class="fonte" style="background-color: #4A70A8">
                            <tr>
                                <th style="font-size: 100% ; color: white" class="text-center fonte">CPF</th>
                                <th style="font-size: 100% ; color: white" class="text-center fonte">Nome</th>
                                <th style="font-size: 100% ; color: white" class="text-center fonte">Nascimento</th>
                                <th style="font-size: 100% ; color: white" class="text-center fonte">Telefone</th>
                                <th style="font-size: 100% ; color: white" class="text-center fonte">Celular</th>
                                <th style="font-size: 100% ; color: white" class="text-center fonte">Regime</th>
                                <th style="font-size: 100% ; color: white" class="text-center fonte">E-mail</th>
                                <th v-if="filtro.vincularProjeto" style="font-size: 100% ; color: white" class="text-center fonte">Projeto</th>
                                <th v-if="filtro.vincularProjeto" style="font-size: 100% ; color: white" class="text-center fonte">Tipo Projeto</th>
                            </tr>
                        </thead>
                        <tbody class="fonte">
                            <tr v-for="(item, index) in item" :key="index" :style=" index % 2 === 0 ? 'background-color: gainsboro' : 'background-color: White'">
                                <td style="font-size: 100%">{{item.cpf}}</td>
                                <td style="font-size: 100%">{{item.nome}}</td>
                                <td style="font-size: 100%">{{item.dataNascimento ? new Date(item.dataNascimento).ddmmyyyy() : ''}}</td>
                                <td style="font-size: 100%">{{item.telefone}}</td>
                                <td style="font-size: 100%">{{item.celular}}</td>
                                <td style="font-size: 100%">{{item.tipoRegimeStr}}</td>
                                <td style="font-size: 100%">{{item.email}}</td>
                                <td v-if="filtro.vincularProjeto" style="font-size: 100%">{{item.projeto}}</td>
                                <td v-if="filtro.vincularProjeto" style="font-size: 100%">{{item.tipoProjeto}}</td>
                            </tr> 
                        </tbody>
                        <tfoot v-if="!filtro.vincularProjeto">
                            <tr>
                                <td colspan="7" class="text-right fonte">
                                    <span style="font-weight: bold">
                                        Total:
                                    </span>
                                    <span>
                                        {{quantidade}}
                                    </span>
                                </td>
                            </tr>
                        </tfoot>
                    </template>
                </v-simple-table>
            </v-col>

        </v-row>

        <v-row v-else>
            <v-col cols="12">
                Nenhum registro foi encontrado.
            </v-col>
        </v-row>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </relatorio-page>
</template>

<script>
import { PessoalService } from '../../../core/services/projetos'
export default {
    
    data: () => ({
        item:{
            required: true
        },
        quantidade: 0,
        filtro: {
            vincularProjeto: false,
            cargo: null,
            escolaridade: null,
            idProjeto: null,
            idTipoProjeto: null,
            tipoRegime: null,
            ativo: null,
            etnia: null,
            sexo: null,
            adesaoInicial: null,
            adesaoFinal: null,
            exportarExcel: false
        },
        service: new PessoalService(),
        overlay: false
    }),
    props:{

    },
    mounted(){
        this.filtro = {
            vincularProjeto: this.$route.query.vincularProjeto == "true" ? true : false,
            cargo: this.$route.query.cargo,
            escolaridade: this.$route.query.escolaridade,
            idProjeto: this.$route.query.idProjeto,
            idTipoProjeto: this.$route.query.idTipoProjeto,
            tipoRegime: this.$route.query.tipoRegime,
            ativo: this.$route.query.ativo,
            etnia: this.$route.query.etnia,
            sexo: this.$route.query.sexo,
            adesaoInicial: this.$route.query.adesaoInicial,
            adesaoFinal: this.$route.query.adesaoFinal
        }

        this.overlay = true

        this.service.Relatorio(this.filtro.vincularProjeto, this.filtro.cargo, this.filtro.idProjeto, this.filtro.idTipoProjeto, this.filtro.tipoRegime, this.filtro.ativo, this.filtro.etnia, this.filtro.escolaridade, this.filtro.sexo, this.filtro.adesaoInicial, this.filtro.adesaoFinal).then(
            res=>{
                this.item = res.data.item1;
                this.quantidade = res.data.item2;
            },
            err=>{
                this.$swal('Aviso', err.message, 'error');
            }
        ).finally(() => {
            this.overlay = false;
        })
    },
    methods:{

    }   

}
</script>

<style>
    .fonte{
        font-size: 70%;
    }
</style>
